module.exports = __webpack_public_path__ + "img/4d8b340.png";